import VerboseDatapoint from './datapoints/VerboseDatapoint';
import { DatapointOptions } from 'owa-analytics-actions';

export function logMountingPerformance(datapointName: string, options?: DatapointOptions) {
    return (target: any) => {
        var original = target;
        var instance;

        // a utility function to generate instances of a class
        function construct(oldConstructor: Function, args: any) {
            var c: any = function(this: any) {
                return oldConstructor.apply(this, args);
            };
            c.prototype = oldConstructor.prototype;
            instance = new c();
            instance.mountingDatapoint = new VerboseDatapoint(datapointName + 'Render', options);
            return instance;
        }

        // the new constructor behaviour
        var f: any = function(...args: any[]) {
            return construct(original, args);
        };

        var originalComponentDidMount = original.prototype.componentDidMount;

        // copy prototype so intanceof operator still works
        f.prototype = original.prototype;

        f.prototype.componentDidMount = function() {
            var returnValue;
            if (originalComponentDidMount) {
                returnValue = originalComponentDidMount.apply(instance);
            }
            this.mountingDatapoint.end();
            return returnValue;
        };

        // return new constructor (will override original)
        return f;
    };
}
